import { Link } from 'gatsby';
import React from 'react';
import { ResourceType } from 'types/resource-type';
import VideoPlayIcon from 'components/atoms/VideoPlayIcon';
import ResourceTypeTag from './ResourceTypeTag';
import moment from 'moment';
import Shave from 'components/atoms/Shave';

interface ResourceTileProps {
  url: string;
  title: string;
  image: string;
  type: ResourceType;
  overrideColor?: string;
  excerpt?: string;
  date?: string;
  large?: boolean;
  noIcon?: boolean;
  noHover?: boolean;
  customerStoriesFullLabel?: boolean;
  noTag?: boolean;
  videoIconInverted?: boolean;
  aspectHeight?: string;
  aspectWidth?: string;
}

const ResourceTile: React.FC<ResourceTileProps> = ({
  url,
  title,
  image,
  excerpt,
  type,
  date,
  overrideColor,
  large,
  noIcon,
  noHover,
  customerStoriesFullLabel,
  noTag,
  videoIconInverted,
  aspectHeight = 'aspect-h-11',
  aspectWidth = 'aspect-w-16',
}) => {
  return (
    <Link
      to={url}
      className={`${
        noHover
          ? ''
          : 'transition-opacity duration-200 ease-in-out hover:opacity-50'
      } block`}
    >
      <div
        className={`relative mb-8 ${
          ['download', 'report'].includes(type)
            ? 'bg-light-grey flex items-center justify-center py-11'
            : `${aspectHeight} ${aspectWidth}`
        }`}
      >
        <img
          src={image}
          alt={title}
          className={`${
            ['download', 'report'].includes(type)
              ? 'w-auto h-40 shadow-lg'
              : 'w-full inset-0 object-cover'
          }`}
        />
        {type === 'video' && (
          <div className="absolute inset-0 flex items-center justify-center">
            <VideoPlayIcon
              background={videoIconInverted ? 'text-white' : undefined}
              foreground={videoIconInverted ? 'text-dark-grey' : undefined}
              className="w-20 h-auto"
            />
          </div>
        )}
        {type === 'event' && noTag && date && (
          <div className="absolute bottom-0 left-0 top-auto right-auto w-auto h-auto px-4 py-px mb-6 ml-6 font-semibold leading-8 text-center bg-white rounded text-15px">
            {moment(date).format('MMMM D, YYYY')} :{' '}
            {moment(date).format('h:mma')}
          </div>
        )}
      </div>
      {!noTag && (
        <ResourceTypeTag
          type={type}
          overrideColor={overrideColor}
          noIcon={noIcon}
          customerStoriesFullLabel={customerStoriesFullLabel}
        />
      )}

      <div className={large ? 'lg:pr-24' : ''}>
        <h2 className="text-2xl font-bold leading-tight tracking-tightest">
          <Shave maxHeight={60}>{title}</Shave>
        </h2>

        {excerpt && (
          <div className="mt-2 tracking-tighter">
            <Shave maxHeight={80}>{excerpt}</Shave>
          </div>
        )}
      </div>
    </Link>
  );
};

export default ResourceTile;
